import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const TrashcanIcon = withSvgIcon(
    <g>
        <path d="M499.3 63h-145V0H145.8v63H.7v20.9h61.7V500h375.3V83.8h61.7V63zM166.6 20.9h166.8V63H166.6V20.9zm250.2 458.2H83.2V83.8h333.6v395.3z" />
        <path d="M333.4 124.7h20.9v291.9h-20.9zM146.6 124.7h19.1v291.9h-19.1zM228.9 145.5H270v271.1h-41.1z" />
    </g>
);
